import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormGroup,
  Grid,
  LinearProgress,
  Link,
  Paper,
  Popper,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import api from '../../services/api';
import HandleSamples from './newHandleSamples';

import InfoIcon from '@mui/icons-material/Info';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TooltipInfo } from 'components/tooltips/tooltipsInfo';
import 'dayjs/locale/pt';
import NumberFormat from 'react-number-format';
import { labelField } from 'utils';
import { POND_STATUS_CYCLE, parameterTypes } from 'utils/consts';
import styleGlobal from '../../Global.module.css';
import AutocompleteParameters from '../../components/AutocompleteParameters';
import GroupButton from '../../components/Buttons/ButtonGroup';
import DialogMain from '../../components/Dialogs/dialogMain';
import Progress from '../../components/Progress';
import Error from '../../components/Snack/Error';
import Success from '../../components/Snack/Success';
import { useStyles } from '../../components/Styles';
import { setDisable } from '../../redux/disable';
import FormDialogContent from '../measurement/formDialog/formDialogContent';
import './styles.css';

export default function Parameters() {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const [locale, setLocale] = React.useState('pt');
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);
  const [forms, setForms] = useState([]);
  const [size, setSize] = useState();
  const [selectedForm, handleForm] = useState('');
  const [pondCycles, setPondCycles] = useState([]);
  const [selectedPondCycle, handlePondCycle] = useState(null);
  const [openPondCycle, setOpenPondCycle] = useState(false);
  const [samples, setSamples] = useState([]);
  const [dataOfImages, setDataOfImages] = useState(new Map());
  const [parameters, setParameters] = useState([]);
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [selectedBeginDate, handleBeginDateChange] = useState(new Date());
  let { id } = useParams();
  const disable = useSelector((state) => state.disable.disable);
  const notIsFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const error = Error();
  const success = Success();
  const parametersIsNull = useState(false);
  const [sampleRef, setSampleRef] = useState([
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
  ]);
  const [openPondModal, setOpenPondModal] = useState(false);
  const [openLinearProgress, setOpenLinearProgress] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);
    handlePondCycle(data.cycle);

    const parametersFormateds = data.samples[0].parameters.map((parameter) => ({
      ...parameter.parameter,
      id: parameter.parameter_id,
      parameter_id: parameter.parameter_id,
      name: parameter.parameter.name,
      sigla: parameter.parameter.unity.sigla,
    }));
    setSelectedParameters(parametersFormateds);

    setSamples(data.samples);

    setSize(data.size);
    if (data.get_at !== '') {
      handleBeginDateChange(new Date(data.get_at));
    }
  }

  function updateSamples(options) {
    formik.setFieldValue('samples', options);
  }

  useEffect(() => {
    api.get(`/cycles/cycle-code/${selectedCycle.id}`).then((pondCycles_) => {
      setPondCycles(
        pondCycles_.data.filter(
          (pond) =>
            pond.status === POND_STATUS_CYCLE.CULTIVANDO ||
            pond.status === POND_STATUS_CYCLE.PREPARANDO
        )
      );
      if (pondCycles_.data.length === 0) setOpenPondCycle(true);
    });
    api.get('/parameters').then((parameters_) =>
      setParameters(
        parameters_.data
          .filter((parameter) => parameter.type === 'Saúde')
          .map((parameter) => ({
            ...parameter,
            parameter_id: parameter.id,
            sigla: parameter.unity.sigla,
            description: '',
          }))
      )
    );
    api.get('/forms').then((forms_) => {
      setForms(forms_.data.filter((form) => form.type === 'Saúde'));
    });
  }, [selectedCycle]);

  useEffect(() => {
    // carrega os dados nos seus devidos campos caso tenha id, do contrário,
    // carrega o formulário vazio para cadastrar um novo
    async function loadData() {
      setOpenProgress(true);
      if (id) {
      }
      setOpenProgress(false);
    }
    loadData();
  }, []);

  /*
  useEffect(() => {
    // Carrega os dados na tabela de cadastro
    if (!id && size > 0 && selectedForm.parameters !== undefined) {
      var parameters = selectedForm.parameters;
      var samples = [];
      for (var i = 0; i < size; i++) {
        samples.push({
          number: i,
          parameters: parameters.map((p) => {
            return {
              parameter_id: p.parameter.id,
              name: p.name,
              description: "",
              value: 0,
            };
          }),
          observation: "",
        });
      }

      setParameters(parameters);
      setSamples(samples);
      //setar imagens
    }
  }, [selectedForm, size, id]); */

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      id
        ? await api.put(`/healthmeasures/${id}`, { ...data })
        : await api.post('/healthmeasures', { ...data });
      success();
      history.push('/analysis');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      cycle: '',
      get_at: '',
      size: '',
      samples: [],
      dataOfImages: new Map(),
      // workers: ""
    },
    validationSchema: Yup.object({
      cycle: Yup.number().required('Campo Obrigatório'),
      size: Yup.number()
        .required('Campo Obrigatório.')
        .min(1, 'Precisa ser acima de 0.')
        .max(50, 'Valor máximo ultrapassado. Diminua o tamanho da amostra.')
        .typeError(
          `O valor deve ser um número inteiro. () => ${size}${typeof size}`
        ),
      get_at: Yup.date().typeError('a data deve ter o formato dd/mm/yyyy'),
    }),
    onSubmit: (values) => {
      if (selectedParameters.length === 0) {
        parametersIsNull[1](true);
        return false;
      }
      values.cycle = selectedPondCycle.id;
      values.samples = samples;
      values.size = size;
      values.dataOfImages = dataOfImages;
      values.get_at = selectedBeginDate;
      // values.workers = selectedWorkers.name
      const help = values.data;
      request(values);
    },
  });

  useEffect(() => {
    formik.values.cycle = selectedPondCycle?.id;
  }, [selectedPondCycle]);

  function handleParameters(parameters) {
    // if(parameters)
    setSelectedParameters(parameters);
  }

  function setRef(data) {
    setSampleRef(data);
  }

  useEffect(() => {
    if (selectedParameters && !id && size) {
      const samples = [];
      // Tava querendo iterar com codicional number < string
      // for (var i = 0; i < size; i++) {
      for (let i = 0; i < size; i++) {
        samples.push({
          number: i,
          parameters: selectedParameters.map((p) => ({
            ...p,
            parameter_id: p.id,
            value: 0,
            name: p.name,
            sigla: p.unity.sigla,
          })),
          observation: '',
        });
      }
      setSamples(samples);
      // setSelectedForm(null)
      formik.setFieldValue('parameters', selectedParameters);
    }
  }, [selectedParameters, size]);

  useEffect(() => {
    // Carrega os dados na tabela de cadastro
    if (selectedForm) {
      if (selectedForm.parameters !== undefined) {
        const parametersFormateds = selectedForm.parameters.map(
          (parameter) => ({
            ...parameter.parameter,
            id: parameter.parameter_id,
            parameter_id: parameter.parameter_id,
            name: parameter.parameter.name,
          })
        );
        setSelectedParameters(parametersFormateds);

        const samples = [];
        // for (var i = 0; i < size; i++) {
        for (let i = 0; i < size; i++) {
          samples.push({
            number: i,
            parameters: parametersFormateds.map((p) => ({
              parameter_id: p.id,
              value: 0,
              name: p.name,
            })),
            observation: '',
          });
        }
        setSamples(samples);
        formik.setFieldValue('parameters', parametersFormateds);
        // setar imagens
      }
    }
  }, [selectedForm, id, size]);

  const amostraMax = 50;
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= amostraMax) return true;
    return false;
  };

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 400,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  /**
   * @param {React.ChangeEvent<{}>} event
   * @param {AutocompleteChangeReason} reason
   */
  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick') {
      setOpenPondModal(false);
    }
    if (reason === 'escapeKeyDown') {
      setOpenPondModal(false);
    }
  };

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}{' '}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados de Análise de Saúde{' '}
              <HtmlTooltip
                title={
                  <>
                    Essa tela permite cadastrar ou editar as análises de saúde
                    (sanidade) dos animais na fazenda. Com essas informações, é
                    possível prever com antecedência problemas na produção,
                    doenças e muito mais.
                  </>
                }
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              {/** *
               *  Diálogos para facilitar cadastro.
               */}
              {openPondCycle ? (
                <DialogMain
                  message="A propridade não possui nenhum viveiro configurado para esse ciclo. Por favor, configure um viveiro para prosseguir."
                  route="/pond"
                />
              ) : null}

              {openForm ? (
                <DialogMain
                  message="Não há nenhum formulário cadastrado. Por favor, cadastre um formulário para prosseguir."
                  route="/form"
                />
              ) : null}
              <Grid container spacing={2}>
                <Dialog
                  style={{ padding: '15rem' }}
                  open={openPondModal}
                  fullWidth
                  maxWidth="lg"
                  onClose={handleCloseModal}
                >
                  {openLinearProgress && <LinearProgress />}
                  <DialogTitle style={{ paddingBottom: '0' }}>
                    <span style={{ paddingLeft: '1rem' }}>
                      Dados do Formulário
                    </span>
                  </DialogTitle>
                  <DialogContent>
                    <FormDialogContent
                      setForms={(data) => {
                        const filteredByMeasurement = data.filter((item) =>
                          item.type.includes('Saúde')
                        );
                        setForms(filteredByMeasurement);
                      }}
                      typeName="Saúde"
                      setOpenPondModal={setOpenPondModal}
                      setOpenAutocomplete={setOpenAutocomplete}
                      setOpenLinearProgress={setOpenLinearProgress}
                    />
                  </DialogContent>
                </Dialog>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <Autocomplete
                      noOptionsText={
                        <Typography>
                          Nenhum viveiro configurado para esse ciclo.
                          <Link
                            style={{ marginLeft: '1%', cursor: 'pointer' }}
                            color="primary"
                            onMouseDown={() => {
                              history.push(
                                !notIsFirstAccess ? '/first-cycle' : '/cycle'
                              );
                            }}
                          >
                            Configurar agora +
                          </Link>
                        </Typography>
                      }
                      color="inherit"
                      name="cycle"
                      options={pondCycles}
                      value={selectedPondCycle}
                      getOptionLabel={(options) => options.pond.description}
                      onChange={(p, v) => {
                        handlePondCycle(v);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={labelField('Viveiro')}
                          variant="outlined"
                          onBlur={formik.handleBlur}
                          error={formik.touched.cycle && formik.errors.cycle}
                          helperText={
                            formik.touched.cycle && formik.errors.cycle
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Grid>

                {!id && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <FormGroup>
                        <Autocomplete
                          open={openAutocomplete}
                          onOpen={() => {
                            setOpenAutocomplete((state) => !state);
                          }}
                          onClose={() => {
                            setOpenAutocomplete((state) => !state);
                          }}
                          noOptionsText="Sem opções"
                          name="form"
                          options={forms}
                          value={selectedForm}
                          getOptionLabel={(options) =>
                            typeof options === 'string' ? options : options.name
                          }
                          onChange={(p, v) => {
                            handleForm(v);
                          }}
                          onBlur={formik.handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Formulário"
                              variant="outlined"
                              // disabled={id?true:false}
                            />
                          )}
                          PopperComponent={(param) => (
                            <Popper {...param}>
                              <Box {...param} />
                              <Paper style={{ height: '100%' }}>
                                <Typography
                                  style={{ padding: '1rem', color: 'gray' }}
                                >
                                  {forms.length === 0
                                    ? 'Não existe formulário cadastrado nessa medição.'
                                    : 'Deseja cadastrar outro formulário?'}{' '}
                                  <Link
                                    style={{ cursor: 'pointer' }}
                                    color="primary"
                                    onMouseDown={() => {
                                      setOpenPondModal((state) => !state);
                                    }}
                                  >
                                    Cadastrar Formulário +
                                  </Link>
                                </Typography>
                              </Paper>
                            </Popper>
                          )}
                        />
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormGroup>
                        <AutocompleteParameters
                          type={parameterTypes.SAUDE}
                          form_id={null}
                          parameters={selectedParameters}
                          options={parameters}
                          callback={handleParameters}
                          parametersIsNull={parametersIsNull}
                        />
                      </FormGroup>
                    </Grid>
                  </>
                )}

                <Grid item xs={6} sm={3}>
                  <FormGroup>
                    <NumberFormat
                      isNumericString
                      fullWidth
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="size"
                      label={labelField('Tamanho da amostra(max: 50)')}
                      variant="outlined"
                      name="size"
                      value={formik.values.size}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={0}
                      disabled={!!id}
                      isAllowed={withValueCap}
                      onValueChange={(e) => {
                        formik.values.size = e.value;
                        setSize(parseInt(e.value));
                      }}
                      onBlur={formik.handleBlur}
                      customInput={TextField}
                      error={formik.touched.size && formik.errors.size}
                      helperText={formik.touched.size && formik.errors.size}
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <FormGroup>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={locale}
                    >
                      <DatePicker
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        label={<div>Data</div>}
                        name="get_at"
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage="Data Inválida"
                        value={selectedBeginDate}
                        onChange={(date) => {
                          handleBeginDateChange(date);
                          formik.setFieldValue('get_at', date);
                        }}
                        onBlur={formik.handleBlur}
                        format="dd/MM/yyyy"
                        // inputFormat="DD/MM/YYYY"
                        fullWidth
                        error={
                          !!(formik.touched.get_at && formik.errors.get_at)
                        }
                        helperText={
                          formik.touched.get_at &&
                          formik.errors.get_at &&
                          formik.errors.get_at
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormGroup>
                </Grid>
              </Grid>

              {/* <FormGroup>
                        <Autocomplete
                            noOptionsText="Sem opções"
                            fullWidth
                            multiple
                            id='worker'
                            options={workers}
                            value={selectedWorkers}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.name}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.name}
                                </React.Fragment>
                            )}
                            onChange={(_, v) => {
                                setSelectedWorkers(v)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant='outlined'
                                    label='Funcionários'
                                    placeholder='Funcionários'
                                />
                            )}
                        />
                    </FormGroup> */}
              <br />

              <FormGroup>
                <FormControl>
                  {/* New handle samples */}
                  <HandleSamples
                    label="Valor"
                    parameters={selectedParameters}
                    samples={samples}
                    id={id}
                    dataOfImages
                    callback={updateSamples}
                    setRef={setRef}
                    sampleRef={sampleRef}
                  />
                </FormControl>
              </FormGroup>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/healthmeasures/"
            routeDelete="/analysis"
            returnRoute="/analysis"
            id={id}
            disable={disable}
            message="A exclusão dessa análise pode levar a exclusão de objetos que dependem dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}
